var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineMessages2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m16.97 21.62-4.01-2.38c-.42-.01-.84-.04-1.24-.1a.76.76 0 0 1-.6-.48c-.1-.26-.05-.54.13-.75.66-.77 1-1.69 1-2.67 0-2.42-2.13-4.39-4.75-4.39-.98 0-1.92.27-2.71.79a.758.758 0 0 1-1.16-.54 7.92 7.92 0 0 1-.05-.85c0-4.96 4.3-8.99 9.58-8.99s9.58 4.03 9.58 8.99c0 2.72-1.26 5.22-3.48 6.93l.34 2.72a1.752 1.752 0 0 1-1.73 1.97c-.31 0-.62-.08-.9-.25zm-3.42-3.78 4.19 2.49c.11.07.2.04.26 0 .05-.03.13-.11.11-.25l-.39-3.16c-.03-.28.09-.55.31-.71 2.04-1.43 3.21-3.61 3.21-5.98 0-4.13-3.62-7.49-8.08-7.49-4.29 0-7.81 3.12-8.07 7.04.75-.29 1.56-.45 2.4-.45 3.45 0 6.25 2.64 6.25 5.89.01.88-.2 1.73-.59 2.51.14-.01.28.03.4.11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.84 22.53a1.37 1.37 0 0 1-.63-1.32l.2-1.54c-1.35-1.1-2.15-2.73-2.15-4.44 0-1.95 1.02-3.77 2.73-4.86a6.444 6.444 0 0 1 3.52-1.03c3.45 0 6.25 2.64 6.25 5.89 0 1.32-.48 2.62-1.36 3.65-1.13 1.37-2.82 2.17-4.68 2.23l-2.44 1.45a1.366 1.366 0 0 1-1.44-.03zm.95-10.9c-1.28.82-2.04 2.16-2.04 3.6 0 1.39.68 2.66 1.88 3.48.23.16.35.43.32.71l-.22 1.71 2.39-1.42c.12-.07.25-.11.38-.11 1.47 0 2.86-.63 3.74-1.7.66-.78 1.01-1.7 1.01-2.68 0-2.41-2.13-4.38-4.75-4.38-.98 0-1.92.27-2.71.79z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineMessages2);
export default __webpack_public_path__ + "static/media/vuesax-outline-messages-2.cf1fdea0873893dccc7a009f3f52e18e.svg";
export { ForwardRef as ReactComponent };